export type ApplierOption =
  | 'Status:Active'
  | 'Status:Inactive'
  | 'Status:Deleted'
  | 'Status:Archived'
  | 'Dispatch'
  | 'Dispatch:Confirm'
  | 'Tags'
  | 'Service'
  | 'Service:Add'
  | 'Service:Change'
  | 'ServiceOption'
  | 'Meta'
  | 'MarketplaceOrderLines'
  | 'Dimensions'
  | 'TariffCodes'
  | 'TariffCodes:Add'
  | 'Dimensions:Add'
  | 'Dimensions:Change'
  | 'Extras'
  | 'Protection'
  | 'Owners'
  | 'Download:Labels'
  | 'Download:CSV:Sold'
  | 'Download:CSV:Booked'
  | 'Download:CSV:Orders'
  | 'Download:PickingList'
  | 'RecipientContactDetails'
  | 'RecipientContactDetails:Add'
  | 'RecipientContactDetails:Change'
  | 'PreferredCollectionDate'
  | 'Sender'
  | 'Recipient'
  | 'MarkAsNotPackaged'
  | 'ItemValue'
  | 'MarkAsPackaged'
  | 'MarkAsDispatched'
  | 'Return'
  | 'Consignment'
  | 'LIST'
  | 'Book';

export const ApplierOptionsForPotentialBulkActions: ApplierOption[] = [
  'Extras',
  'Service:Add',
  'Dimensions:Add',
  'Protection'
];
